export const UPDATE_POPUP_PLAYER = 'UPDATE_POPUP_PLAYER';
export const POPUP_PLAYER_READY = 'POPUP_PLAYER_READY';
